// LIST
export const FETCH_TOC = "app/TOC/FETCH_TOC";
export const FETCH_TOC_SUCCESS = "app/TOC/FETCH_TOC_SUCCESS";
export const FETCH_TOC_FAILURE = "app/TOC/FETCH_TOC_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/TOC/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/TOC/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/TOC/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_TOC = "app/TOC/ADD_TOC";
export const ADD_TOC_SUCCESS = "app/TOC/ADD_TOC_SUCCESS";
export const ADD_TOC_FAILURE = "app/TOC/ADD_TOC_FAILURE";
// EDIT
export const EDIT_TOC = "app/TOC/EDIT_TOC";
export const EDIT_TOC_SUCCESS = "app/TOC/EDIT_TOC_SUCCESS";
export const EDIT_TOC_FAILURE = "app/TOC/EDIT_TOC_FAILURE";
// DELETE
export const DELETE_TOC = "app/TOC/DELETE_TOC";
export const DELETE_TOC_SUCCESS = "app/TOC/DELETE_TOC_SUCCESS";
export const DELETE_TOC_FAILURE = "app/TOC/DELETE_TOC_FAILURE";
